/**
 * WaterIcon — sanitized from `assets/newSvg/water.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function WaterIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M19,13 L19,20 C19,21.0543909 18.18415,21.9181678 17.1492661,21.9945144 L17,22 L7,22 C5.94563773,22 5.08183483,21.18415 5.00548573,20.1492661 L5,20 L5,13 L19,13 Z M9,15 C8.48716857,15 8.06449347,15.386027 8.0067278,15.8833761 L8,16 L8,18 C8,18.5523 8.44772,19 9,19 C9.51283143,19 9.93550653,18.613973 9.9932722,18.1166239 L10,18 L10,16 C10,15.4477 9.55228,15 9,15 Z M17,2 C18.0543909,2 18.9181678,2.81587733 18.9945144,3.85073759 L19,4 L19,11 L5,11 L5,4 C5,2.94563773 5.81587733,2.08183483 6.85073759,2.00548573 L7,2 L17,2 Z M9,5 C8.44772,5 8,5.44772 8,6 L8,8 C8,8.55228 8.44772,9 9,9 C9.55228,9 10,8.55228 10,8 L10,6 C10,5.44772 9.55228,5 9,5 Z"
        fill={color}
      />
    </Svg>
  );
}

export default WaterIcon;
